module.exports = __webpack_public_path__ + "img/79.56e60e36.jpg";